var _defs, _path, _use, _use2, _use3, _use4, _use5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "cn_svg__a",
  fill: "#ff0",
  d: "M-.6.8 0-1 .6.8-1-.3h2z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ee1c25",
  d: "M0 0h640v480H0z"
})), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cn_svg__a",
  width: 30,
  height: 20,
  transform: "matrix(71.9991 0 0 72 120 120)"
})), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cn_svg__a",
  width: 30,
  height: 20,
  transform: "matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
})), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cn_svg__a",
  width: 30,
  height: 20,
  transform: "matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
})), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cn_svg__a",
  width: 30,
  height: 20,
  transform: "matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
})), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cn_svg__a",
  width: 30,
  height: 20,
  transform: "matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
})));
export default SvgCn;